import { DkimStatus } from "@redotech/redo-model/email/domain-verification";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getEmailDomainsForTeam = {
  name: "getEmailDomainsForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(
    z.object({ domain: z.string(), dkimStatus: createEnum(DkimStatus) }),
  ),
};
